export const isNullOrUndefined = (object: any) => {
	return object === null || object === undefined;
};

export const isNotNullOrUndefined = (object: any) => {
	return !isNullOrUndefined(object);
};
